import { IRutinInfo } from '../../../../Types/RutinInfoType';
import { rutinInfos } from '../Const/RutinInfo';

//Hitta rutinInfo för en viss key. Ger bättre typning än att anropa rutinInfos[rutinKey] direkt.
export const findRutinInfo = (rutinKey: string): IRutinInfo | undefined =>
  rutinInfos[rutinKey];
